import {validateNINumber} from '../../../../../utility/validationUtil';

export const MAX_FSM_CONTACTS = 5;

export const isContactComplete = (contact) => {
    if (!contact) {
        return false;
    }

    const niValidation = validateNINumber(contact.insuranceNumber);
    return !!contact.fullName &&
        !!contact.dateOfBirth &&
        !!contact.insuranceNumber &&
        niValidation.isValid &&
        !contact.fullNameError &&
        !contact.dateOfBirthError &&
        !contact.insuranceNumberError;
};

/**
 * Parent contacts are shown and required only for eligibility checks
 * (consent-to-check / last 6 years). Hidden when currently in receipt.
 */
export const shouldShowFsmContacts = ({lastFree, isNotApplicable}) =>
    !!(lastFree || isNotApplicable);

/** @deprecated Use shouldShowFsmContacts — same rule. */
export const requiresFsmContacts = shouldShowFsmContacts;

export const areFsmContactsValid = ({lastFree, isNotApplicable, contacts}) => {
    const showContacts = shouldShowFsmContacts({lastFree, isNotApplicable});
    if (!showContacts) {
        return true;
    }

    if (!Array.isArray(contacts) || contacts.length < 1 || contacts.length > MAX_FSM_CONTACTS) {
        return false;
    }

    return contacts.every(isContactComplete);
};

export const contactsPayloadForSave = ({lastFree, isNotApplicable, contacts}) => {
    if (!shouldShowFsmContacts({lastFree, isNotApplicable})) {
        return [];
    }

    return contacts.map(({fullName, dateOfBirth, insuranceNumber}) => ({
        fullName,
        dateOfBirth,
        insuranceNumber,
    }));
};
